/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { MultipleUploadResponseDto } from '../model';
// @ts-ignore
import type { UploadsControllerDeleteFile200Response } from '../model';
// @ts-ignore
import type { UploadsControllerDeleteFile404Response } from '../model';
// @ts-ignore
import type { UploadsControllerDeleteFile500Response } from '../model';
// @ts-ignore
import type { UploadsControllerUploadMultipleFiles400Response } from '../model';
// @ts-ignore
import type { UploadsControllerUploadMultipleFiles500Response } from '../model';
/**
 * UploadsApi - axios parameter creator
 * @export
 */
export const UploadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Remove a file from Firebase Storage using its full storage path
         * @summary Delete a file from Firebase Storage
         * @param {string} filePath Full path to the file in storage (URL encoded)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerDeleteFile: async (filePath: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filePath' is not null or undefined
            assertParamExists('uploadsControllerDeleteFile', 'filePath', filePath)
            const localVarPath = `/api/uploads/{filePath}`
                .replace(`{${"filePath"}}`, encodeURIComponent(String(filePath)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload up to 10 files simultaneously with optional folder organization and custom naming
         * @summary Upload multiple files to Firebase Storage
         * @param {Array<File>} files Array of files to upload (max 10 files)
         * @param {string} [customFileName] Optional custom filename (without extension)
         * @param {string} [folder] Optional folder path to organize files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerUploadMultipleFiles: async (files: Array<File>, customFileName?: string, folder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('uploadsControllerUploadMultipleFiles', 'files', files)
            const localVarPath = `/api/uploads/multiple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (customFileName !== undefined) { 
                localVarFormParams.append('customFileName', customFileName as any);
            }
                if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
            if (folder !== undefined) { 
                localVarFormParams.append('folder', folder as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadsApi - functional programming interface
 * @export
 */
export const UploadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadsApiAxiosParamCreator(configuration)
    return {
        /**
         * Remove a file from Firebase Storage using its full storage path
         * @summary Delete a file from Firebase Storage
         * @param {string} filePath Full path to the file in storage (URL encoded)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadsControllerDeleteFile(filePath: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadsControllerDeleteFile200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadsControllerDeleteFile(filePath, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UploadsApi.uploadsControllerDeleteFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload up to 10 files simultaneously with optional folder organization and custom naming
         * @summary Upload multiple files to Firebase Storage
         * @param {Array<File>} files Array of files to upload (max 10 files)
         * @param {string} [customFileName] Optional custom filename (without extension)
         * @param {string} [folder] Optional folder path to organize files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadsControllerUploadMultipleFiles(files: Array<File>, customFileName?: string, folder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultipleUploadResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadsControllerUploadMultipleFiles(files, customFileName, folder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UploadsApi.uploadsControllerUploadMultipleFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UploadsApi - factory interface
 * @export
 */
export const UploadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadsApiFp(configuration)
    return {
        /**
         * Remove a file from Firebase Storage using its full storage path
         * @summary Delete a file from Firebase Storage
         * @param {string} filePath Full path to the file in storage (URL encoded)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerDeleteFile(filePath: string, options?: RawAxiosRequestConfig): AxiosPromise<UploadsControllerDeleteFile200Response> {
            return localVarFp.uploadsControllerDeleteFile(filePath, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload up to 10 files simultaneously with optional folder organization and custom naming
         * @summary Upload multiple files to Firebase Storage
         * @param {Array<File>} files Array of files to upload (max 10 files)
         * @param {string} [customFileName] Optional custom filename (without extension)
         * @param {string} [folder] Optional folder path to organize files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadsControllerUploadMultipleFiles(files: Array<File>, customFileName?: string, folder?: string, options?: RawAxiosRequestConfig): AxiosPromise<MultipleUploadResponseDto> {
            return localVarFp.uploadsControllerUploadMultipleFiles(files, customFileName, folder, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadsApi - object-oriented interface
 * @export
 * @class UploadsApi
 * @extends {BaseAPI}
 */
export class UploadsApi extends BaseAPI {
    /**
     * Remove a file from Firebase Storage using its full storage path
     * @summary Delete a file from Firebase Storage
     * @param {string} filePath Full path to the file in storage (URL encoded)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadsApi
     */
    public uploadsControllerDeleteFile(filePath: string, options?: RawAxiosRequestConfig) {
        return UploadsApiFp(this.configuration).uploadsControllerDeleteFile(filePath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload up to 10 files simultaneously with optional folder organization and custom naming
     * @summary Upload multiple files to Firebase Storage
     * @param {Array<File>} files Array of files to upload (max 10 files)
     * @param {string} [customFileName] Optional custom filename (without extension)
     * @param {string} [folder] Optional folder path to organize files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadsApi
     */
    public uploadsControllerUploadMultipleFiles(files: Array<File>, customFileName?: string, folder?: string, options?: RawAxiosRequestConfig) {
        return UploadsApiFp(this.configuration).uploadsControllerUploadMultipleFiles(files, customFileName, folder, options).then((request) => request(this.axios, this.basePath));
    }
}

